export default __webpack_public_path__ + "static/media/press-08.2c85e386.jpg";